import React, { useMemo } from 'react';

// helpers
import { FormValuesModel } from '..';
import { useFormikContext } from 'formik';

// components
import ConfirmAction from './ConfirmAction';
import BulkCompleted from './BulkCompleted';

const InnerForm = () => {
  const { values } = useFormikContext<FormValuesModel>();

  const content = useMemo(() => {
    switch (values.step) {
      case 'confirm-action':
        return <ConfirmAction />;

      case 'completed':
        return <BulkCompleted />;
    }
  }, [values.step]);

  return <>{content}</>;
};

export default InnerForm;
